import { trans, getResourcePath, getPagePath } from '@spotahome/soyuz/client';

import { Button, FooterSimplified } from '@spotahome/ui-library';

import HeaderContainer from '@spotahome/landings-common/src/components/HeaderContainer';
import Hero from '@spotahome/landings-common/src/components/Hero';

import ContractTypesDetails from './ContractTypesDetails';

import './ContractTypes.scss';

const ContractTypes = () => (
  <div>
    <Hero
      menu={<HeaderContainer />}
      title={trans('contract_types.title')}
      subtitle={trans('contract_types.first_claim.text')}
      backgroundImage={`url(${getResourcePath(
        '/images/contract-types/background-header.png'
      )})`}
    />

    <ContractTypesDetails />

    <div className="contract-types__claim-container">
      <div className="grid__wrapper--inner">
        <div className="grid">
          <div className="grid__col grid__col--2-of-3 grid__col--centered">
            <p className="contract-types__claim">
              {trans('contract_types.second_claim.text')}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div className="contract-types__action">
      <Button
        size="big"
        href={getPagePath('externals.help-center')}
        className="button--info"
      >
        {trans('contract-types.action')}
      </Button>
    </div>

    <FooterSimplified />
  </div>
);

export default ContractTypes;
